import { render } from "./AdminNavigationDrawer.vue?vue&type=template&id=281240bc"
import script from "./AdminNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./AdminNavigationDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__